module.exports = __webpack_public_path__ + "img/how-it-works-thumbnail.069b60e9.png";